import AppButton from '../../../../../components/common/AppButton';
import {SVG} from '../../../../../constants/assetLists';

type Props = {
  currentStep: number;
  totalSteps: number;
  isFirstTab: boolean;
  isLastTab: boolean;
  onNext: () => void;
  onPrev: () => void;
};

function NetworkSetupNavBar({
  currentStep,
  totalSteps,
  isFirstTab,
  isLastTab,
  onNext,
  onPrev,
}: Props) {
  const progressPercent = totalSteps > 0 ? (currentStep / totalSteps) * 100 : 0;

  return (
    <div className="flex items-center gap-4 flex-1 max-w-[1300px] min-w-0">
      <div className="w-full h-[9px] bg-gray90 overflow-hidden flex flex-row-reverse shrink">
        <div
          className="h-full bg-tealBlue transition-all duration-300 ease-out"
          style={{width: `${progressPercent}%`}}
        />
      </div>

      <div className="flex items-center gap-3 shrink-0">
        <AppButton
          variant="secondary"
          py="8px"
          px="24px"
          disabled={isFirstTab}
          iconStart={
            <img
              src={SVG.greaterThanIcon}
              alt=""
              className="w-[10px] h-[10px] object-contain"
            />
          }
          onClick={onPrev}>
          הקודם
        </AppButton>

        <AppButton
          variant="primary"
          py="8px"
          px="24px"
          disabled={isLastTab}
          iconEnd={
            <img
              src={SVG.lessThanWhiteIcon}
              alt=""
              className="w-[10px] h-[10px] object-contain"
            />
          }
          onClick={onNext}>
          הבא
        </AppButton>
      </div>
    </div>
  );
}

export default NetworkSetupNavBar;
